module.exports = __webpack_public_path__ + "img/icon-copy.e54f23fd.svg";